import React from 'react';
import { motion } from 'framer-motion';
export function ConsequencesSection() {
  return <section className="py-20 px-4 bg-[#E8E0D5]" data-id="element-101">
      <div className="max-w-5xl mx-auto" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-103">
          <h2 className="font-display font-bold text-2xl sm:text-3xl md:text-4xl text-teal mb-4 break-words leading-tight" data-id="element-104">
            El costo de seguir esperando es demasiado alto.
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-105">
          {[{
          icon: '🧠',
          title: 'Mental',
          desc: 'Niebla mental, dificultad para concentrarte, decisiones en piloto automático y olvidos constantes.'
        }, {
          icon: '💔',
          title: 'Emocional',
          desc: 'Distancia en tus relaciones, irritabilidad crónica, sensación de vacío y llanto repentino.'
        }, {
          icon: '🏃',
          title: 'Físico',
          desc: 'Tensión muscular, insomnio resistente, problemas digestivos y un sistema inmune debilitado.'
        }].map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-6 sm:p-8 rounded-2xl shadow-sm border border-urgency/20" data-id="element-106">
              <div className="text-4xl mb-3 sm:mb-4" data-id="element-107">{item.icon}</div>
              <h3 className="font-heading font-bold text-lg sm:text-xl text-teal mb-2 sm:mb-3" data-id="element-108">
                {item.title}
              </h3>
              <p className="text-neutral-gray text-sm leading-relaxed font-sans break-words" data-id="element-109">
                {item.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-110">
          <p className="font-display italic text-xl md:text-2xl text-teal" data-id="element-111">
            "Cada día que pasa sin regularte es un día más en modo
            supervivencia."
          </p>
        </motion.div>
      </div>
    </section>;
}